import { SvgIcon, type SvgIconProps } from './svgIcon'

export const ArrowForwardIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <path
      d="M16.5 7.5L21.5 12.5M21.5 12.5L16.5 17.5M21.5 12.5L3.5 12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </SvgIcon>
)
